import React from "react";

// A drawing-note line, not a nav item.
//
// It used to say "a full readable version of this site is at /projects", which
// is now false twice over: this sheet is already real HTML - semantic headings,
// native disclosures, gated by axe in CI - so it IS the readable version of
// itself, and /projects was the old site, which is retired. The only thing on
// the site that cannot be read is the drawing, so that is the only thing this
// points at.
const SheetNote = () => (
  <p className="sheet-readable-note">
    The drawing on the front page is also written out at{" "}
    <a href="/readable">/readable</a>
  </p>
);

export default SheetNote;
